
import React from 'react';
import { X } from 'lucide-react';

interface FilePreviewProps {
  files: File[];
  onRemove: (index: number) => void;
  renderFilePreview: (file: File) => React.ReactNode;
  isExpanded: boolean;
}

const FilePreview = ({
  files,
  onRemove,
  renderFilePreview,
  isExpanded
}: FilePreviewProps) => {
  if (files.length === 0) return null;
  
  return (
    <div className={`px-4 py-2 border-t border-goldcore/20 flex flex-wrap gap-2 ${isExpanded ? 'bg-knightblack/50' : ''}`}>
      {files.map((file, index) => (
        <div key={index} className="relative group">
          {renderFilePreview(file)}
          <button 
            onClick={() => onRemove(index)}
            className="absolute -top-2 -right-2 bg-knightblack rounded-full p-1 opacity-90 hover:opacity-100"
          >
            <X size={14} className="text-victorycoral" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default FilePreview;
